import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96c34cea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-12 ss-detalhes-fundo-cinza" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Estoque")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-6 ss-detalhes-fundo-cinza ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Disponível")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-6 ss-detalhes-fundo-cinza ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Utilizado")
], -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-12 ss-detalhes-fundo-cinza" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Estoque")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-12 ss-detalhes-fundo-cinza ss-alinhar-texto-direita" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Qtde Entrada")
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_11 = {
  key: 0,
  class: "ant-col ant-col-xs-12 ant-col-xl-6"
}
const _hoisted_12 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_component_a_popover, {
      key: _ctx.props.codigoProdutoDefinicao,
      visible: _ctx.computedApresentarEstoques,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedApresentarEstoques) = $event)),
      placement: "top",
      trigger: "focus"
    }, {
      content: _withCtx(() => [
        (_ctx.props.movimentarSaida)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
          : (_ctx.props.movimentarEntrada)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedItensEstoque, (itemEstoque) => {
          return (_openBlock(), _createElementBlock("div", {
            key: itemEstoque.codigoEstoqueItem,
            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.computedPopOverHover = true)),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.computedPopOverHover = false)),
            class: "ant-row"
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.obterDescricaoEstoque(itemEstoque.codigoEstoque)), 1),
            (_ctx.props.movimentarSaida)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.obterQuantidadeDisponivel(itemEstoque.codigoEstoqueItem),
                    permitirValorNegativo: true,
                    disabled: true,
                    quantidadeCasasDecimais: _ctx.obterCasasDecimaisEstoque(itemEstoque.codigoEstoqueItem)
                  }, null, 8, ["valor", "quantidadeCasasDecimais"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.props.movimentarSaida? 'ant-col ant-col-xs-12 ant-col-xl-6':'ant-col ant-col-xs-12 ant-col-xl-12')
            }, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.buscandoDados
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: itemEstoque.quantidade,
                    "onUpdate:valor": ($event: any) => ((itemEstoque.quantidade) = $event),
                    quantidadeCasasDecimais: _ctx.obterCasasDecimaisEstoque(itemEstoque.codigoEstoqueItem),
                    permitirValorNegativo: true,
                    class: _normalizeClass(_ctx.props.classCss),
                    onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.computedInputFocus = true)),
                    onBlur: _ctx.blur,
                    onValorDigitado: _cache[1] || (_cache[1] = ($event: any) => (_ctx.calcularQuantidades()))
                  }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais", "class", "onBlur"])
                ]),
                _: 2
              }, 1032, ["spinning"])
            ], 2)
          ], 32))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])),
    _createElementVNode("div", {
      id: _ctx.props.identificacaoElemento
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 8, _hoisted_12)
  ]))
}